import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/* ============================================================================
   EXPORTACIÓN DE TABLAS · Excel y PDF
   ----------------------------------------------------------------------------
   Extraído TAL CUAL de `DataTableExportable.js` al migrar /pacientes: mismas
   columnas exportadas, mismos encabezados del PDF, mismo formato de nombre de
   archivo (`Titulo_dd-mm-aaaa_hh-mm-ss`) y mismos estilos de la tabla PDF. El
   objetivo era no perder la exportación al cambiar de tabla, y que el archivo
   que sale hoy sea idéntico al de ayer.

   `DataTableExportable.js` se deja intacto: ya no lo usa nadie, pero no se
   borran componentes existentes.
   ========================================================================== */

export const marcaDeTiempo = () => {
    const ahora = new Date();
    const fecha = ahora.toLocaleDateString("es-EC").replace(/\//g, "-");
    const hora = ahora.toLocaleTimeString("es-EC").replace(/:/g, "-");
    return `${fecha}_${hora}`;
};

/**
 * @param {object[]} filas   filas YA filtradas (se exporta lo que se ve)
 * @param {string[]} campos  claves a exportar, en orden
 * @param {string} titulo    nombre de la hoja y del archivo
 */
export function exportarExcel(filas, campos, titulo = "Listado") {
    const datos = filas.map((fila) => {
        const nueva = {};
        campos.forEach((clave) => {
            nueva[clave] = fila[clave];
        });
        return nueva;
    });

    const hoja = XLSX.utils.json_to_sheet(datos);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Listado");
    const buffer = XLSX.write(libro, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${titulo}_${marcaDeTiempo()}.xlsx`);
}

/**
 * @param {object} encabezados  mapa clave -> título legible en el PDF
 */
export function exportarPDF(filas, campos, titulo = "Listado", encabezados = {}) {
    const doc = new jsPDF();
    doc.text(titulo, 14, 10);

    autoTable(doc, {
        head: [campos.map((clave) => encabezados[clave] || clave)],
        body: filas.map((fila) => campos.map((clave) => fila[clave] || "")),
        startY: 20,
        styles: {
            fontSize: 8,
            cellPadding: 2,
            overflow: "linebreak",
        },
        headStyles: {
            fillColor: [22, 160, 133],
            fontSize: 9,
            halign: "center",
        },
        bodyStyles: {
            valign: "top",
        },
    });

    doc.save(`${titulo}_${marcaDeTiempo()}.pdf`);
}

/** Búsqueda local sobre TODOS los campos, igual que la de la tabla anterior. */
export function filtrarPorTexto(filas, texto) {
    const buscado = String(texto || "").toLowerCase();
    if (!buscado) return filas;
    return filas.filter((fila) =>
        Object.values(fila).some((valor) => String(valor).toLowerCase().includes(buscado))
    );
}
